<template>
  <div v-if="show" class="modal-backdrop">
    <div class="modal">
      <h3>Смена пароля</h3>
      <input v-model="newPassword" type="password" placeholder="Новый пароль" />
      <input v-model="confirmPassword" type="password" placeholder="Подтвердите пароль" />
      <button @click="handleChangePassword" :disabled="changingPassword">
        {{ changingPassword ? 'Смена пароля...' : 'Сменить' }}
      </button>

      <div v-if="statusMessage" :class="['status-message', statusType]">
        {{ statusMessage }}
        <span v-if="statusType === 'success'" class="close-status" @click="clearStatus">×</span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ChangePasswordModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    userEmail: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      newPassword: '',
      confirmPassword: '',
      changingPassword: false,
      statusMessage: '',
      statusType: ''
    };
  },
  methods: {
    async handleChangePassword() {
      if (this.newPassword.length < 6) {
        this.showStatus("Пароль должен содержать минимум 6 символов", "error");
        return;
      }
      if (this.newPassword !== this.confirmPassword) {
        this.showStatus("Пароли не совпадают", "error");
        return;
      }

      this.changingPassword = true;

      try {
        await axios.post(process.env.VUE_APP_API_URL + '/api/polygon/change_password', {
          params: {
            Password: this.newPassword,
            Email: this.userEmail
          }
        });
        localStorage.setItem('is_onetime_password', 'false');
        this.showStatus("Пароль успешно изменён", "success");

        setTimeout(() => {
          this.$emit('password-changed');
          this.resetForm();
        }, 2000);
      } catch (error) {
        console.error(error);
        this.showStatus("Ошибка при смене пароля", "error");
      } finally {
        this.changingPassword = false;
      }
    },
    showStatus(message, type) {
      this.statusMessage = message;
      this.statusType = type;
    },
    clearStatus() {
      this.statusMessage = '';
      this.statusType = '';
    },
    resetForm() {
      this.newPassword = '';
      this.confirmPassword = '';
      this.clearStatus();
    }
  }
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(2px);
}

.modal {
  background: #ffffff;
  padding: 24px 20px;
  border-radius: 10px;
  width: 90%;
  max-width: 360px;
  box-sizing: border-box;
  overflow: hidden;
  word-wrap: break-word;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.modal h3 {
  margin-top: 0;
  margin-bottom: 16px;
  font-size: 20px;
  text-align: center;
  color: #333;
}

.modal input {
  display: block;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  padding: 10px 12px;
  margin-bottom: 14px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s;
  overflow: hidden;
}

.modal input:focus {
  border-color: #007bff;
  outline: none;
}

.modal button {
  width: 100%;
  padding: 10px 12px;
  font-size: 15px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.modal button:disabled {
  background-color: #a0c4ff;
  cursor: not-allowed;
}

.modal button:hover:not(:disabled) {
  background-color: #0056b3;
}

.status-message {
  margin-top: 16px;
  padding: 10px 12px;
  border-radius: 6px;
  font-size: 14px;
}

.status-message.error {
  background-color: #ffebee;
  color: #d32f2f;
  border: 1px solid #ef9a9a;
}

.status-message.success {
  background-color: #e8f5e9;
  color: #2e7d32;
  border: 1px solid #a5d6a7;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-status {
  cursor: pointer;
  font-size: 18px;
  font-weight: bold;
  margin-left: 8px;
}
</style>